export interface IIntegrationItem {
    url: string;
    imageUrl: string;
    label: string;
    key: string;
}
